import { forwardRef } from 'react';
import { Icon, IconName, IconVariant, PositionStrict, Sized } from '@optimus-web/core';
import { AlignedTooltipedSpan } from './style';
import { getTooltipValue } from './utils';

interface Props extends Sized {
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    value: IconName;
    tooltipPosition?: PositionStrict;
    iconVariant?: IconVariant;
    'data-test-id'?: string;
}

export interface TooltippedIconProps extends Props {
    tooltip?: Mews.TextKey | React.ReactNode;
}

export interface ServerTooltippedIconProps extends Props {
    tooltip: string;
}

export const TooltippedIcon = forwardRef<HTMLSpanElement, TooltippedIconProps>(
    ({ tooltip, size, value, iconVariant, ...other }, ref) => (
        <AlignedTooltipedSpan tooltip={getTooltipValue(tooltip)} {...other}>
            <Icon size={size} variant={iconVariant} value={value} ref={ref} />
        </AlignedTooltipedSpan>
    )
);

export const ServerTooltippedIcon = forwardRef<HTMLSpanElement, ServerTooltippedIconProps>(
    ({ tooltip, size, value, iconVariant, tooltipPosition, onClick }, ref) => (
        <AlignedTooltipedSpan tooltip={tooltip} onClick={onClick} tooltipPosition={tooltipPosition}>
            <Icon size={size} variant={iconVariant} value={value} ref={ref} />
        </AlignedTooltipedSpan>
    )
);
